import script from "./YoutubeWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./YoutubeWrapper.vue?vue&type=script&setup=true&lang=js"

import "./YoutubeWrapper.vue?vue&type=style&index=0&id=8e3cf11a&scoped=true&lang=css"

import exportComponent from "/Users/jonathan/Projects/kubiek/kronenburg/web/themes/custom/ef2_custom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e3cf11a"]])

export default __exports__